import { createContext, useContext, useEffect, useState } from 'react';
import { getAllTableData } from '../services/recentPayments';
import { DateFormats, formatDate } from '../utils/utils';
import { AuthStore } from './auth';

const date = new Date();

export type TransactionHistoryState = {
  recentPayments: [];
};

export const TransactionHistoryStore = createContext<TransactionHistoryState>({
    recentPayments: [],
});

const { Provider } = TransactionHistoryStore;

export const TransactionHistoryProvider = ({ children }: any) => {
  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const [transactionHistoryState, setTransactionHistoryState] =
    useState<TransactionHistoryState>({
        recentPayments: [],
    });

  useEffect(() => {
    let count = 0;
    let recentPayments = getAllTableData(selectedPersona).map((x: any) => {
      count += 5;

      return {
        ...x,
        requestedDate: formatDate(
          new Date(date.getFullYear(), date.getMonth(), date.getDate() - count),
          DateFormats.US
        ),
      };
    });

    setTransactionHistoryState({
        recentPayments,
    });
  }, [selectedPersona]);

  return <Provider value={transactionHistoryState}>{children}</Provider>;
};
